import request from '../helpers/request';

const deleteRequestAttachment = async (requestId, attachId) => {
  const res = await request.delete(
    `/Request/attachment`,
    { requestId, attachId },
    'Не удалось удалить файл'
  );

  return res;
};

export default deleteRequestAttachment;
